import React, { useEffect, useState } from 'react';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import "./_multi-valued-input.scss"

export const MultiValuedInput = ({
  field: { name },
  form: { errors, touched, setFieldValue, values, setFieldTouched },
  label,
  disabled = false,
  labelCol,
  inputCol,
  placeholder,
  forceShowError,
  prefix = null,
  helpingText = '* Enter emails separated by space',
  onCustomChange = null,
  maxInputs = null,

}) => {
  const forceError = forceShowError && forceShowError[name];
  const isError = (touched[name] || forceError) && errors[name];
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    let { [name]: notificationEmail = [] } = values;

    if (notificationEmail) {
      try {
        if (Array.isArray(notificationEmail) && notificationEmail.length) {
          setEmails(notificationEmail);
          return;
        }

        if (typeof notificationEmail === "string") {
          if (notificationEmail.startsWith("[")) {
            notificationEmail = JSON.parse(notificationEmail);
          }
          setEmails(notificationEmail.split(","));
        } else {
          setEmails([]);
        }
      } catch (error) {
        console.log(error);
        setEmails([]);
      }
    } else {
      setEmails([]);
    }
  }, [values[name]]);

  const onBlur = () => {
    const val = inputValue;
    if (emails.includes(val.split(' ')[0])) {
      setInputValue('');
      return;
    }
    const updatedEmails = emails;
    if (['', ' '].includes(val.split(' ')[0])) return;
    updatedEmails.push(val.split(' ')[0]);
    setEmails(updatedEmails);
    setFieldValue(name, updatedEmails.toString());
    setInputValue('');

    if (onCustomChange) {
      const result = onCustomChange(updatedEmails, 'add', val.split(' ')[0]);
      if (result) {
        setEmails(result);
      }
    }
  };

  const renderValue = (e) => {
    let val = e.target.value;
    if (prefix) {
      if (val.length > 0 && val.charAt(0) !== prefix) {
        val = prefix + val.trim();
      }
    }
    setInputValue(val);
    if (val.includes(' ')) {
      if (emails.includes(val.split(' ')[0])) {
        setInputValue('');
        return;
      }
      const updatedEmails = emails;
      updatedEmails.push(val.split(' ')[0]);
      setEmails(updatedEmails);
      setFieldValue(name, updatedEmails.toString());
      setInputValue('');

      if (onCustomChange) {
        const result = onCustomChange(updatedEmails, 'add', val.split(' ')[0]);
        if (result) {
          setEmails(result);
        }
      }
    }
  };

  const removeValue = (index) => {
    const updatedEmails = emails.filter(function (_, i) {
      return i !== index;
    });
    setEmails(updatedEmails);
    setFieldValue(name, updatedEmails.toString());

    if (onCustomChange) {
      const result = onCustomChange(updatedEmails, 'remove', emails[index]);
      if (result) {
        setEmails(result);
      }
    }
  };

  return (
    <div className="row">
      <div className={labelCol}>
        <p className="profile-label">{label}</p>
      </div>
      <div className={inputCol}>
        <FormGroup controlId={name} validationState={isError ? 'error' : null}>
          <div
            style={disabled ? { backgroundColor: 'var(--grey-5, #F2F2F3)' } : {}}
            className="multi-valued-input multi-valued-input-Insta no-padding profile-input"
            onClick={() => setFieldTouched(name, true)}
          >
            {emails.map((v, index) => (
              <div className="value-container" key={index}>
                <div className="value">{v}</div>
                <div
                  className="icon-container"
                  onClick={() => {
                    if (disabled) {
                      return;
                    }
                    removeValue(index);
                  }}
                >
                  <i className="fa fa-times" aria-hidden="true" />
                </div>
              </div>
            ))}
            <input
              style={disabled ? { backgroundColor: 'var(--grey-5, #F2F2F3)', height: '100%' } : { height: '100%' }}
              disabled={disabled || (maxInputs && emails.length >= maxInputs)}
              value={inputValue}
              className="input"
              onChange={renderValue}
              onBlur={onBlur}
              placeholder={emails.length ? '' : placeholder}
            />
          </div>
          <p className="helping-text">{helpingText}</p>
          {isError && <HelpBlock>{errors[name]}</HelpBlock>}
        </FormGroup>
      </div>
    </div>
  );
};

MultiValuedInput.defaultProps = {
  labelCol: 'col-lg-4 col-form-label',
  inputCol: 'col-lg-12'
};
